export default __webpack_public_path__ + "static/media/img_requisitos.6b37b1d4.png";